import { AccessRequest } from 'gabi-api-ts/v2/patient/command/patient_command';
import { PatientPermissionManagementCommandServiceClient } from 'gabi-api-ts/v2/patient/command/patient_command.client';

import {grpcRequest} from '@/services/api-requests/grpc-request-ts';
import {ApiTransportOptions} from '@/services/api-transport/transport-service';

type PatientPermissionManagementServiceData = {
    patientId: string,
    groupId: string,
};

export class PatientPermissionManagementService {
    async getRequest(idToken: string, options: ApiTransportOptions & { data: PatientPermissionManagementServiceData }) {
        switch(options.modelName) {
        case 'patientGroupGrantAccess': {
            return this.patientGroupGrantAccess(idToken, options.data);
        }
        case 'patientGroupRevokeAccess': {
            return this.patientGroupRevokeAccess(idToken, options.data);
        }

        default: {
            console.error('UNKNOWN REQUEST', options.modelName);
        }
        }
    }

    async patientGroupGrantAccess(idToken: string, data: PatientPermissionManagementServiceData) {
        const out = await grpcRequest(
            idToken,
            PatientPermissionManagementCommandServiceClient,
            PatientPermissionManagementCommandServiceClient.prototype.grantAccess,
            {
                groupId: { id: data.groupId },
                patientId: { id: data.patientId },
            } as AccessRequest,
        );
        return out.response;
    }

    async patientGroupRevokeAccess(idToken: string, data: PatientPermissionManagementServiceData) {
        const out = await grpcRequest(
            idToken,
            PatientPermissionManagementCommandServiceClient,
            PatientPermissionManagementCommandServiceClient.prototype.revokeAccess,
            {
                groupId: { id: data.groupId },
                patientId: { id: data.patientId },
            } as AccessRequest,
        );
        return out.response;
    }
}
